import { useState } from 'react';
import { SpeakButton } from '../components/SpeakButton';
import { ttsTextOf } from '../components/speech';
import { KANA_GROUPS } from '../screens/library/kanaLibraryData';
import type { KanaGroupKey } from '../screens/library/types';

export function KanaLibraryPage({ narrow = false, onStudy }: { narrow?: boolean; onStudy: (key: KanaGroupKey, title: string) => void }) {
  const [groupKey, setGroupKey] = useState<KanaGroupKey>('hiragana');
  const group = KANA_GROUPS.find((g) => g.key === groupKey)!;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 18, fontFamily: 'var(--font-vi)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', gap: 6, background: 'var(--surface-tint)', borderRadius: 'var(--radius-control)', padding: 4, flex: 1, maxWidth: 420 }}>
          {KANA_GROUPS.map((g) => {
            const active = g.key === groupKey;
            return (
              <button
                key={g.key}
                role="tab"
                aria-selected={active}
                onClick={() => setGroupKey(g.key)}
                style={{
                  flex: 1,
                  height: 38,
                  borderRadius: 10,
                  border: 'none',
                  cursor: 'pointer',
                  fontFamily: 'var(--font-vi)',
                  fontSize: 13.5,
                  fontWeight: 600,
                  background: active ? 'var(--surface-page)' : 'transparent',
                  color: active ? 'var(--ink)' : 'var(--text-secondary)',
                  boxShadow: active ? 'var(--shadow-raised)' : 'none',
                }}
              >
                {g.title}
              </button>
            );
          })}
        </div>
        <button
          onClick={() => onStudy(group.key, group.title)}
          style={{
            height: 46,
            padding: '0 20px',
            borderRadius: 'var(--radius-control)',
            background: 'var(--cta-default)',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'var(--font-vi)',
            fontWeight: 700,
            fontSize: 14.5,
            whiteSpace: 'nowrap',
          }}
        >
          Học bằng flashcard
        </button>
      </div>

      <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{group.subtitle}</div>

      <div style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fill,minmax(${group.key === 'radicals' ? 150 : 110}px,1fr))`, gap: 10 }}>
        {group.cards.map((item) => {
          if (item.itemType === 'VOCAB' || item.itemType === 'GRAMMAR' || item.itemType === 'KANJI') return null;
          return (
            <div
              key={item.id}
              style={{
                background: 'var(--surface-page)',
                border: '1px solid var(--border-default)',
                borderRadius: 'var(--radius-card)',
                padding: '12px 10px',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontFamily: 'var(--font-jp)', fontSize: 24, color: 'var(--ink)', lineHeight: 1.2 }}>{item.character}</div>
                <div style={{ fontSize: 11.5, color: 'var(--text-secondary)', fontWeight: 600, marginTop: 2 }}>{item.romaji}</div>
                {item.meaningVi && <div style={{ fontSize: 11.5, color: 'var(--text-secondary)', marginTop: 2 }}>{item.meaningVi}</div>}
              </div>
              <SpeakButton text={ttsTextOf(item)} variant="outline" size={34} label={`Nghe phát âm ${item.character}`} />
            </div>
          );
        })}
      </div>
      {narrow && <div style={{ height: 8 }} />}
    </div>
  );
}
